import { DvToolbarAction, DvToolbarActionEvent } from '@devinco/ui/grid';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { getStandardActionPreset } from '@features/vt-grid/presets/preset-actions';
import { VippsPaymentDto } from '@pages/vipps-payments/interfaces';
import { ColDef } from 'ag-grid-community';

@Injectable({ providedIn: 'root' })
export class PaymentsGridService {
  getGridActions(
    refundFn: (event: DvToolbarActionEvent<VippsPaymentDto>) => void
  ): DvToolbarAction<VippsPaymentDto>[] {
    return [
      {
        icon: 'send_money_coin',
        clickFn: refundFn,
        tooltipKey: 'General.RefundTransaction',
        hidden: environment.production,
      },
      {},
      ...getStandardActionPreset(),
    ];
  }

  getColumns(): ColDef<VippsPaymentDto>[] {
    return [
      {
        field: 'VippsPaymentID',
        type: ColumnType.Id,
        headerName: 'General.Id',
        hide: true,
      },
      {
        field: 'VippsMerchantID',
        type: ColumnType.Number,
        headerName: 'VippsPayment.VippsMerchantID',
        hide: true,
      },
      {
        field: 'Description',
        type: ColumnType.Text,
        headerName: 'VippsPayment.Description',
      },
      {
        field: 'Amount',
        type: ColumnType.Number,
        headerName: 'VippsPayment.Amount',
      },
      {
        field: 'Currency',
        type: ColumnType.Text,
        headerName: 'VippsPayment.Currency',
        hide: true,
      },
      {
        field: 'PaymentStatus',
        type: ColumnType.Text,
        headerName: 'VippsPayment.PaymentStatus',
      },
      {
        field: 'CreatedAt',
        type: ColumnType.DateTime,
        headerName: 'VippsPayment.CreatedAt',
      },
      {
        field: 'CompletedAt',
        type: ColumnType.DateTime,
        headerName: 'VippsPayment.CompletedAt',
      },
      {
        field: 'Reference',
        type: ColumnType.Text,
        headerName: 'VippsPayment.Reference',
      },
      {
        field: 'IdempotencyKey',
        type: ColumnType.Text,
        headerName: 'VippsPayment.IdempotencyKey',
        hide: true,
      },
      {
        field: 'PspReference',
        type: ColumnType.Text,
        headerName: 'VippsPayment.PspReference',
        hide: true,
      },
    ];
  }
}
